const reading = [
  // --- blogs ---
  {
    type: "blog",
    title: "Moratorium... for what?",
    url: "https://onethousandmeans.substack.com/p/moratorium-for-what",
    description: "As support grows for pausing data center construction, the purpose of a pause loses clarity.",
    image: "https://substackcdn.com/image/fetch/$s_!jfOo!,w_1456,c_limit,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2Fb5722d9c-40bf-4d30-a3a9-aa53e18f3cbe_1160x652.jpeg",
    author: "Alexei Gannon",
    source: "One Thousand Means",
    publishedDate: "2026-05-01",
  },
  {
    type: "blog",
    title: "New Frontier Models Are Faster, Not More Reliable, at Spatial Biology",
    url: "https://blog.latch.bio/p/new-frontier-models-are-faster-not",
    description: "Overall accuracy for GPT-5.5 and Opus 4.7 remains flat on SpatialBench. Scientist-reviewed trajectories reveal persistent gaps in assay-aware biological judgment.",
    image: "",
    author: "Kenny Workman, Hannah Le, Zhen Yang, and Harihara Muralidharan",
    source: "LatchBio",
    publishedDate: "2026-04-29",
  },
  {
    type: "blog",
    title: "Democratic Governance of AI Is the Real Solution",
    url: "https://jacobin.com/2026/04/ai-data-center-moratorium-democracy",
    description: "The potential for serious negative effects from the AI boom demands robust deliberation and real democratic governance. Data center moratoria won't get us there.",
    image: "https://media.jacobin.com/images/2026/4/364048011805.jpg",
    author: "Holly Buck",
    source: "Jacobin",
    publishedDate: "2026-04-26",
  },
  {
    type: "blog",
    title: "AI Won't Automatically Accelerate Clinical Trials",
    url: "https://www.asimov.press/p/ai-clinical-trials",
    description: "",
    image: "https://substackcdn.com/image/fetch/$s_!TIDP!,w_1456,c_limit,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2F3da51221-8a5a-4720-a29d-a9ebd50dcedc_2000x1260.jpeg",
    author: "Ruxandra Teslo",
    source: "Asimov Press",
    publishedDate: "2026-02-27",
  },
  {
    type: "blog",
    title: "A Visual Guide to DNA Sequencing",
    url: "https://www.asimov.press/p/dna-sequencing",
    description: "How to 'read' nucleic acids, from Sanger to nanopores.",
    image: "https://substackcdn.com/image/fetch/$s_!ezte!,w_1456,c_limit,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2F69bb038e-36d7-4ac7-9543-1567b44b3a43_1714x1080.gif",
    author: "Evan DeTurk",
    source: "Asimov Press",
    publishedDate: "2026-02-26",
  },
  {
    type: "blog",
    title: "Life's most important problems",
    url: "https://blog.jck.bio/p/lifes-most-important-problems",
    description: "Richard Hamming's question applied to the life sciences.",
    image: "",
    author: "Jacob Kimmel",
    source: "Creode",
    publishedDate: "2026-01-20",
  },
  {
    type: "blog",
    title: "Creating therapeutic abundance",
    url: "https://blog.jck.bio/p/creating-therapeutic-abundance",
    description: "On limiting reagents in the medicine production function.",
    image: "",
    author: "Jacob Kimmel",
    source: "Creode",
    publishedDate: "2025-07-07",
  },
  {
    type: "blog",
    title: "China's Clinical Trial Boom",
    url: "https://www.asimov.press/p/china-trials",
    description: "In 2017, there were just over 600 clinical trials initiated in China. By 2023, that number was nearly 2,000. How can American companies kick off a similar boom?",
    image: "",
    author: "Hiya Jain",
    source: "Asimov Press",
    publishedDate: "2025-04-24",
  },
  {
    type: "blog",
    title: "Cancer has a surprising amount of detail",
    url: "https://www.owlposting.com/p/cancer-has-a-surprising-amount-of",
    description: "",
    image: "https://substackcdn.com/image/fetch/$s_!HzCX!,w_2400,c_limit,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2Fcbabfbed-ed1a-4a35-a664-7971fab8d96c_2912x1632.png",
    author: "Abhishaike Mahajan",
    source: "Owl Posting",
    publishedDate: "2025-10-26",
  },
  {
    type: "blog",
    title: "A socratic dialogue over why drugs work at all",
    url: "https://www.owlposting.com/p/why-do-drugs-work-at-all",
    description: "",
    image: "https://substackcdn.com/image/fetch/$s_!a56A!,w_2400,c_limit,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2Fc112debd-4d0b-418f-9e9a-d103aac13dd3_2912x1632.png",
    author: "Abhishaike Mahajan",
    source: "Owl Posting",
    publishedDate: "2024-08-09",
  },
  {
    type: "blog",
    title: "On creating 'new knobs of control' in biology",
    url: "https://www.owlposting.com/p/on-creating-new-knobs-of-control",
    description: "",
    image: "https://substackcdn.com/image/fetch/$s_!kB4A!,w_2400,c_limit,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2Fdda37299-49c5-488c-8735-4f1008962589_2912x1632.png",
    author: "Abhishaike Mahajan",
    source: "Owl Posting",
    publishedDate: "2026-04-10",
  },
  {
    type: "blog",
    title: "There aren't enough smart people in biology doing something boring",
    url: "https://www.owlposting.com/p/there-arent-enough-smart-people-in",
    description: "",
    image: "https://substackcdn.com/image/fetch/$s_!Ii5i!,w_2400,c_limit,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2Fbd11d0a3-6b5b-4b99-a154-6d3f6c03afea_2912x1632.png",
    author: "Abhishaike Mahajan and Eryney Marrogi",
    source: "Owl Posting",
    publishedDate: "2024-10-21",
  },
  {
    type: "blog",
    title: "Ask not why would you work in biology, but rather: why wouldn't you?",
    url: "https://www.owlposting.com/p/ask-not-why-would-you-work-in-biology",
    description: "",
    image: "https://substackcdn.com/image/fetch/$s_!RZqT!,w_2400,c_limit,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2F333c2fa3-223f-475f-bd2f-f24037f23164_2912x1632.png",
    author: "Abhishaike Mahajan",
    source: "Owl Posting",
    publishedDate: "2025-10-02",
  },

  // --- papers ---
];

export default reading;
